import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=0c473d4c&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=0c473d4c&prod&scoped=true&lang=css"
import style1 from "./Inbox.vue?vue&type=style&index=1&id=0c473d4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c473d4c",
  null
  
)

export default component.exports